/* BricoDock : la liste « Caractéristiques » de la description devient un tableau à deux colonnes,
   ouvert d'office. Affichage seulement : la description enregistrée dans Shopify ne change pas. */
(function () {
  function tableau() {
    document.querySelectorAll('details.vld-acc').forEach(function (d) {
      var s = d.querySelector('summary');
      if (!s || !/^\s*caract/i.test(s.textContent) || d.getAttribute('data-bd-specs')) return;
      var ul = d.querySelector('ul');
      if (!ul) return;
      d.setAttribute('data-bd-specs', '1');
      var t = document.createElement('table'), tb = document.createElement('tbody');
      t.className = 'bd-specs';
      t.appendChild(tb);
      Array.prototype.forEach.call(ul.children, function (li) {
        li.textContent.split('|').forEach(function (part) {
          part = part.replace(/\s+/g, ' ').trim();
          if (!part) return;
          var tr = document.createElement('tr'), m = part.match(/^(.{2,40}?)\s:\s(.+)$/);
          if (m) {
            var th = document.createElement('th'), td = document.createElement('td');
            th.scope = 'row'; th.textContent = m[1]; td.textContent = m[2];
            tr.appendChild(th); tr.appendChild(td);
          } else {
            var tdl = document.createElement('td');
            tdl.colSpan = 2; tdl.textContent = part; tr.appendChild(tdl);
          }
          tb.appendChild(tr);
        });
      });
      ul.parentNode.replaceChild(t, ul);
      d.open = true;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tableau);
  else tableau();
})();
